import { AuthProvider as PropelAuthProvider } from '@propelauth/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import RouteGuard from './components/RouteGuard';
import { AUTH_URL } from './config/env';
import { AssistantProvider } from './context/AssistantContext';
import { AuthProvider } from './context/AuthContext';
import AuthCallback from './pages/AuthCallback';
import './skeleton.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

const isAuthCallback = window.location.pathname === '/auth/callback';

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <PropelAuthProvider authUrl={AUTH_URL}>
      {isAuthCallback ? (
        <AuthCallback />
      ) : (
        <AuthProvider>
          <RouteGuard>
            <AssistantProvider>
              <App />
            </AssistantProvider>
          </RouteGuard>
        </AuthProvider>
      )}
    </PropelAuthProvider>
  </React.StrictMode>,
);
